import React from "react";
import ProjectsComponents from "../components/HomePages/ProjectsComponents";
import Banner from "../components/Banner";
import AboutSection from "../components/AboutSection";
import ContactForm from "../components/ContactForm";
import useFetchProjects from "../hooks/useFetchProjects";
import { translations } from "../translations"; // Import des traductions

const HomePages = () => {
  const { projects, loading, error, currentLang } = useFetchProjects(); // Récupère la langue actuelle

  // Fonction pour filtrer les projets selon leur catégorie
  const getProjectsByCategory = (category) => {
    return projects.filter((project) => project.category === category);
  };

  if (loading) return <p className="text-center">Chargement en cours...</p>;
  if (error)
    return <p className="text-center text-red-500">Erreur : {error}</p>;

  return (
    <div>
      <Banner />

      <ProjectsComponents
        id="ai"
        category={
          translations[currentLang]?.artificialIntelligence ||
          "Artificial Intelligence"
        }
        categorySlug="ai"
        projects={getProjectsByCategory("Artificial Intelligence")}
      />
      <ProjectsComponents
        id="design"
        category={
          translations[currentLang]?.industrialDesign || "Industrial Design"
        }
        categorySlug="design"
        projects={getProjectsByCategory("Industrial Design")}
      />
      <ProjectsComponents
        id="graphic"
        category={translations[currentLang]?.graphicDesign || "Graphic Design"}
        categorySlug="graphic"
        projects={getProjectsByCategory("Graphic Design")}
      />

      <ProjectsComponents
        id="lab"
        category={translations[currentLang]?.creativeLab || "Creative Lab"}
        categorySlug="lab"
        projects={getProjectsByCategory("Creative Lab")}
      />
      <AboutSection />
      <ContactForm />
    </div>
  );
};

export default HomePages;
